export const QuestionsDialogFormViewStyles = {
  bannerContainer: 'mb-5',
  buttonContainer: 'w-32 mt-5'
}
